import dayjs from "dayjs";
import { Inspection, InspectionElement } from "../types/inspection";

export const formatInspectionDate = (inspection: Inspection) => {
    const { inspectionDateFrom: DateTimeFrom, inspectionDateTo: DateToFrom } = inspection;
    let date = "";

    if (DateTimeFrom) {
        date += dayjs(DateTimeFrom).format("DD/MM/YYYY");
    }

    if (DateTimeFrom && DateToFrom) {
        date += " - ";
    }

    if (DateToFrom) {
        date += dayjs(DateToFrom).format("DD/MM/YYYY");
    }

    return date;
}

export const getInspectionPhotoFolders = (inspection: Inspection) => {
    const photoFolders: InspectionElement[] = [];

    if (inspection.inspectionReport) {
        inspection.inspectionReport.forEach((inspectionElement) => {
            if (inspectionElement.ElementType === 2 && inspectionElement.AvailableForCustomer) {
                photoFolders.push(inspectionElement);
            }
        })
    }

    return photoFolders.sort((a, b) => a.SortOrder - b.SortOrder);
}
